import { Button, Card, DrawerStepper, Skeleton, Text } from '@mercai/clever'
import { DrawerShowProps } from './drawer-show.type'

import { formatNumber } from '@/helpers'
import { ROUTES_ADMIN } from '@/router'
import { useForecastDetail } from '@/services'
import { useTranslation } from 'react-i18next'
import styles from './drawer-show.module.css'

export const DrawerShow = ({ isOpen, onClose, uuid }: DrawerShowProps) => {
  const { t } = useTranslation('screenSuppliers')

  const searchParams = new URLSearchParams(window.location.search)

  const supplierForecastUuid = searchParams.get('showDrawerShow') || uuid || ''

  const { data: supplierForecastDetail, isLoading } =
    useForecastDetail(supplierForecastUuid)

  const Component = () => {
    return (
      <div className={styles.core}>
        <Card className={styles['card-product']}>
          <Text variant="title-base" className={styles['card-product-title']}>
            {
              supplierForecastDetail?.data?.supplierProduct?.catalogProduct
                ?.attributes?.title
            }
          </Text>
          <div>
            <div>
              <Text>
                <strong>{t('drawerShowTotalQuantityUsed')}: </strong>
                {supplierForecastDetail?.data?.availableQuantity
                  ? formatNumber(
                      supplierForecastDetail.data.availableQuantity,
                      undefined,
                      0,
                    )
                  : 0}{' '}
                kg
              </Text>
            </div>
          </div>
        </Card>

        <div>
          <Text
            variant="title-medium"
            className={styles['card-product-sale-order-items-title']}
          >
            {t('drawerShowSaleOrdersItemsTitle')}
          </Text>

          <div>
            {supplierForecastDetail?.data?.productQuotations?.length &&
            supplierForecastDetail?.data?.productQuotations?.length > 0 ? (
              supplierForecastDetail.data.productQuotations.map((item) => (
                <Card
                  className={styles['card-product-sale-order-item']}
                  key={item.uuid}
                >
                  <div className={styles['card-product-sale-order-item-left']}>
                    <Text
                      variant="title-base"
                      className={
                        styles['card-product-sale-order-item-left-title']
                      }
                    >
                      {t('drawerShowSaleOrdersItemsOrder')} #
                      {item?.quotation?.orders?.[0]?.reference}
                    </Text>
                    {/* <div>
                        <Text
                          variant="text-xsmall"
                          className={
                            styles[
                              'card-product-sale-order-item-left-generated-on'
                            ]
                          }
                        >
                          {t('drawerShowSaleOrdersItemsGeneratedOn')}:{' '}
                          {item?.quotation?.orders?.[0]?.createdAt
                            ? formatDate(item.quotation?.orders?.[0]?.createdAt)
                            : '-'}
                        </Text>
                      </div> */}

                    <Text
                      variant="title-large"
                      className={
                        styles['card-product-sale-order-item-left-quantity']
                      }
                    >
                      -{item?.quantity} Kg
                    </Text>
                  </div>
                  <Button
                    href={ROUTES_ADMIN.ORDER_CENTER.ALL.SHOW.fullPath(
                      item?.quotation?.orders?.[0]?.uuid || '',
                    )}
                    target="_blank"
                    variant="light"
                    model="pill"
                    size="small"
                  >
                    {t('drawerShowSaleOrdersItemsButton')}
                  </Button>
                </Card>
              ))
            ) : (
              <Text variant="text-base" className={styles['empty-label']}>
                {t('drawerShowSaleOrdersItemsEmptyLabel')}
              </Text>
            )}
          </div>
        </div>
      </div>
    )
  }

  const Loading = () => {
    return (
      <div className={styles.core}>
        <Card className={styles['card-product']}>
          <Text variant="title-base" className={styles['card-product-title']}>
            <Skeleton width="100%" height="1.5rem" />
          </Text>
          <div>
            <Text>
              <Skeleton width="100%" height="1.5rem" />
            </Text>

            <Text>
              <Skeleton width="100%" height="1.5rem" />
            </Text>
          </div>
        </Card>

        <div>
          <Text
            variant="title-medium"
            className={styles['card-product-sale-order-items-title']}
          >
            {t('drawerShowSaleOrdersItemsTitle')}
          </Text>

          <div>
            {[1, 2].map((item) => (
              <Card
                className={styles['card-product-sale-order-item']}
                key={item}
              >
                <div className={styles['card-product-sale-order-item-left']}>
                  <div>
                    <Text
                      variant="title-base"
                      className={
                        styles['card-product-sale-order-item-left-title']
                      }
                    >
                      <Skeleton width="9rem" height="1.5rem" />
                    </Text>

                    <div
                      className={
                        styles['card-product-sale-order-item-left-quantity']
                      }
                    >
                      <Skeleton width="5rem" height="3rem" />
                    </div>
                  </div>
                </div>
                <Skeleton width="150px" height="1.6rem" />
              </Card>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <DrawerStepper
      isOpen={isOpen}
      onHandleOpen={onClose}
      initialStep="root"
      translations={{
        optional: '',
      }}
      title={t('drawerShowTitle')}
      description={t('drawerShowDescription')}
      steps={{
        root: {
          backNavigate: 'root',
          isOptional: false,
          component: () => (isLoading ? <Loading /> : <Component />),
          footer: () => (
            <div className={styles.footer}>
              <Button variant="secondary" onClick={onClose}>
                {t('backButton')}
              </Button>
            </div>
          ),
        },
      }}
    />
  )
}
